export const paths = {
    HOME: (menuId = ':menuId') => `/${menuId}`,
    SECTION: (menuId = ':menuId', section = ':section') => `/${menuId}/sections/${section}`,
};
